import { Typography } from "@material-ui/core"
import React from "react"
import Layout from "../components/layout"
import ListaDeCategoriasYProductos from "../components/lista-de-categorias-y-productos"
import Spacer from "../components/spacer"
export default function Home() {
  return (
    <Layout>
      <Spacer pixels={36}></Spacer>
      <Typography
        variant="h1"
        component="h1"
        color="primary"
        gutterBottom={false}
      >
        Fiammengo SRL
      </Typography>
      <Typography
        variant="h6"
        component="h6"
        color="primary"
        style={{ paddingLeft: 8 }}
      >
        Productos, servicios y soluciones
      </Typography>
      <Spacer pixels={36}></Spacer>
      <div style={{ marginTop: "10px" }}>
        <ListaDeCategoriasYProductos slug="/" />
      </div>
    </Layout>
  )
}
